import { Button, Icon } from "@trimble/modus-cmx";

type RemoveIconButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  "size"
> & {
  size?: React.ComponentProps<typeof Icon>["size"];
};

const RemoveIconButton = (props: RemoveIconButtonProps) => {
  const { disabled, size = "sm", ...rest } = props;

  return (
    <Button
      {...rest}
      variant="borderless"
      color="tertiary"
      shape="circle"
      size={size}
      disabled={disabled}
    >
      <Icon
        name="delete"
        decorative
        size={size}
        variant="solid"
        style={{
          color: "var(--modus-wc-color-error)",
          opacity: disabled ? 0.5 : 1,
        }}
      />
    </Button>
  );
};

export default RemoveIconButton;
